export default Object.freeze({
  COMMON_ADMIN_TOOL_TYPE_SERVICE: '서비스어드민', // common.admin.tool.type.service
  COMMON_YEAR: '년',
  COMMON_MONTH: '월',
  COMMON_DAY: '일',
  COMMON_WON: ' 원',
  COMMON_PERIOD: '기간',
  COMMON_SAVE_UPDATE: '변경사항 저장',
  COMMON_SAVE_CONFIRM: '변경된 내용을 저장하시겠습니까?',
  COMMON_SAVE_SUCCESS: '변경사항이 저장 되었습니다.',

  // 파트너조회
  PAYCOSHOP_PARTNER_KEYWORD: '파트너명',
  COMMON_PLACEHOLDER_KEYWORD: '검색어 입력',
  COMMON_SEARCH: '조회',
  COMMON_RESET: '초기화',
  COMMON_CANCEL: '취소',
  COMMON_RESULT: '조회결과',
  COMMON_DETAILS: '상세보기',
  COMMON_CASE: '건',
  COMMON_SPOT: '순위',
  COMMON_EACH: '개 보기',
  COMMON_EACH2: '개',
  COMMON_PAGE_SIZE: '{0}개 보기',
  COMMON_DOWNLOAD: '다운로드',
  COMMON_DOWNLOADEXCEL: '엑셀 다운로드',
  COMMON_SETTLEMENT_DOWNLOADEXCEL: '정산상세 엑셀 다운로드',
  COMMON_FEE_ORDER_DOWNLOADEXCEL: '정산상세(주문별) 엑셀 다운로드',
  COMMON_TERM: '기간',
  COMMON_TODAY: '오늘',
  COMMON_YESTERDAY: '어제',
  COMMON_3_DAY: '3일',
  COMMON_7_DAY: '7일',
  COMMON_6_DAY: '6일',
  COMMON_30_DAY: '30일',
  COMMON_60_DAY: '60일',
  COMMON_90_DAY: '90일',
  COMMON_1_WEEK: '1주일',
  COMMON_1_MONTH: '1개월',
  COMMON_2_MONTH: '2개월',
  COMMON_3_MONTH: '3개월',
  COMMON_6_MONTH: '6개월',
  COMMON_1_YEAR: '1년',
  COMMON_REQUIRED: '필수입력',
  COMMON_SHEETS: '장',
  COMMON_CLOCK: '시',
  COMMON_ALL_CHECK: '전체선택',
  COMMON_SELECT: '선택',
  COMMON_NOT_SELECT: '선택 안함',
  COMMON_SUN: '일요일',
  COMMON_MON: '월요일',
  COMMON_TUE: '화요일',
  COMMON_WED: '수요일',
  COMMON_THU: '목요일',
  COMMON_FRI: '금요일',
  COMMON_SAT: '토요일',
  COMMON_SUN_SHOR: '일',
  COMMON_MON_SHOR: '월',
  COMMON_TUE_SHOR: '화',
  COMMON_WED_SHOR: '수',
  COMMON_THU_SHOR: '목',
  COMMON_FRI_SHOR: '금',
  COMMON_SAT_SHOR: '토',
  COMMON_MORE_THAN: '이상',
  COMMON_BELOW: '이하',
  COMMON_SALE: '할인',
  COMMON_MAX: '최대',
  COMMON_INPUT_FORMAT_ERR: '입력형식이 잘못되었습니다.',
  COMMON_DATE_SPAN_ERR: '시작일자는 종료일자보다 클 수 없습니다.',
  COMMON_PLEASE_INPUT: '검색어를 입력하세요.',
  COMMON_FILE_SIZE_ERR: '{0}KB 이하의 이미지만 업로드 가능합니다.\r\n({1}KB)',
  COMMON_FILE_SIZE_ERR_IMG: '등록 실패 하였습니다.\n최대 {0}까지 등록가능합니다.',
  COMMON_FILE_YTPE_ERR: '이미지 파일만 등록해주세요.',
  COMMON_FILE_YTPE_ERR_IMAGE: '이미지파일(Jpg,jpge,gif,png,bmp)만 등록해주세요.',
  COMMON_SERVER_ERROR_MSG: '서버접속이 원할하지 않습니다. 잠시 후 재시도 해주세요.',
  PAYCOSHOP_PARTNER_PRODUCT_DISPLAY_SETTING: '상품전시설정',
  PAYCOSHOP_PARTNER_AOS_DISPLAY: 'aos전시',
  PAYCOSHOP_PARTNER_IOS_DISPLAY: 'ios전시',
  PAGE_WRITABLE_NONE: '권한이 없습니다.',
  PAYCO: 'PAYCO',
  ACCUMULATION_DEFAULT_NAME: '적립금',
  COMMON_MORE_VIEW: '더보기',

  // header (상단 메뉴)
  VIEW_LAYOUT_DEFAULT_HEADER_SIR: '님', // view.layout.default.header.sir
  MAIN_ADMIN_HEADER_CHANGE_PASSWORD: '비밀번호 변경', // main.admin.header.change.password
  MAIN_ADMIN_HEADER_SETTING: '설정', // main.admin.header.setting
  VIEW_COMMON_OPEN_ALL_MENU: '전체메뉴 열기', // view.common.open.all.menu
  SIGN_OUT: '로그아웃', // sign.out
  VIEW_COMMON_CLOSE_ALL_MENU: '전체메뉴 닫기',
  VIEW_COMMON_LOGIN: '로그인', // view.common.login
  INTEGRATED_LOGIN: 'NHN커머스 통합계정으로 로그인',
  ALERT_INTEGRATED_LOGIN_FAIL: '접속 가능한 쇼핑몰이 없습니다. NHN커머스 사이트에서 쇼핑몰을 신청해 주세요.',
  // header (모바일 앱 다운로드)
  SHOP_BY_MOBILE_APP_DOWNLOAD: 'shop by 모바일 어드민 App 다운로드',
  MANAGE_SHOPPING_MALLS_WITH_YOUR_SMARTPHONE_ANYTIME_ANYWHERE:
    '언제, 어디서나 스마트폰으로 쇼핑몰을 편하게 관리해보세요.',
  QR_CODE_DOWNLOAD: 'QR코드로 다운받기',
  MOVE_LINK_DOWNLOAD: '링크로 이동하여 다운받기',
  MANUAL: '매뉴얼',

  COMMON_MALL: '쇼핑몰',
  COMMON_PRODUCT_NAME: '상품명',
  COMMON_PRODUCT_NO: '상품번호',
  COMMON_ADD: '추가',
  COMMON_COPY: '복사',
  COMMON_MODIFY: '수정',
  COMMON_REGISTER: '등록',
  COMMON_NOT_REGISTER: '등록 안 함',
  COMMON_INSERT: '입력',
  COMMON_DELETE: '삭제',
  COMMON_SAVE: '저장',
  COMMON_CONFIRM: '확인',
  COMMON_APPLY: '적용',
  COMMON_CLOSE: '닫기',
  COMMON_BASIC: '기본',
  COMMON_VIEW: '보기',
  COMMON_REGISTER_ADMIN_NAME: '쿠폰등록자',
  COMMON_REGISTER_YMDT: '등록일',
  COMMON_FINAL_UPDATE: '최종수정',
  COMMON_UPDATE_ADMIN_NAME: '최종수정자',
  COMMON_UPDATE_YMDT: '최종수정일',
  COMMON_COPY_INSERT: '복사등록',
  COMMON_PAGE_SIZE_10: '10개 보기',
  COMMON_PAGE_SIZE_30: '30개 보기',
  COMMON_PAGE_SIZE_50: '50개 보기',
  COMMON_PAGE_SIZE_100: '100개 보기',
  COMMON_PAGE_SIZE_200: '200개 보기',
  COMMON_PAGE_SIZE_500: '500개 보기',
  COMMON_PAGE_SIZE_1000: '1000개 보기',

  // index(메인화면)
  // main top
  VIEW_INDEX_SALESSTATUS: '판매 현황',
  VIEW_INDEX_MINITITLE_1MONTH: '최근 1개월',
  VIEW_INDEX_MINITITLE_1WEEK: '최근 1주일',
  VIEW_INDEX_SALESSTATUSGUIDE: '판매현황 가이드',
  VIEW_INDEX_DEPOSIT_WAIT: '입금대기',
  VIEW_INDEX_DEPOSIT_WAIT_GUIDE: '주문 후 입금되지 않은 주문입니다.',
  VIEW_INDEX_NEWORDER: '결제완료',
  VIEW_INDEX_NEWORDER_GUIDE: '결제완료된 주문입니다.',
  VIEW_INDEX_ORDERLI2: '상품준비/배송준비',
  VIEW_INDEX_ORDERLI3: '상품을 준비하여 송장번호 입력 후 신속히 발송해주세요.',
  VIEW_INDEX_ORDERLI4: '배송중',
  VIEW_INDEX_ORDERLI5: '상품이 구매자에게 배송중입니다.',
  VIEW_INDEX_ORDERLI6: '배송완료',
  VIEW_INDEX_ORDERLI7: '고객이 상품을 수령하였습니다.',
  VIEW_INDEX_ORDERLI8: '배송보류',
  VIEW_INDEX_ORDERLI9: '배송을 보류 처리한 주문 건 입니다. 배송보류 해제 처리 시에 출고준비처리/출고 처리가 가능합니다.',
  VIEW_INDEX_ORDERLI10: '',
  VIEW_INDEX_ORDERLI11: '',
  VIEW_INDEX_CASE: '건',
  VIEW_INDEX_PRODUCTPREPARE: '상품준비',
  VIEW_INDEX_DELIVERYPREPARE: '배송준비',
  VIEW_INDEX_DELIVERYING: '배송중',
  VIEW_INDEX_DELIVERYDONE: '배송완료',
  VIEW_INDEX_HOLDDELIVERY: '배송보류',
  VIEW_INDEX_PROCESSINGDELAYSTATUS: '처리지연 현황',
  VIEW_INDEX_MINITITLE_3MONTH: '최근 3개월',
  VIEW_INDEX_DELAYGUIDE: '처리지연 현황 가이드',
  VIEW_INDEX_DELAYLI1: '발송지연',
  VIEW_INDEX_DELAYLI2: '주문접수일시부터 1영업일 이상 경과된 주문 건입니다.',
  VIEW_INDEX_DELAYLI3: '취소지연',
  VIEW_INDEX_DELAYLI4: '취소신청일시부터 1영업일 이상 경과된 취소 요청 건입니다.',
  VIEW_INDEX_DELAYLI5: '반품지연',
  VIEW_INDEX_DELAYLI7: '교환지연',
  VIEW_INDEX_DELAYLI9: '답변지연',
  VIEW_INDEX_DELAYLI12: '배송보류지연',
  VIEW_INDEX_DELAY_RETURN_GUIDE1: '반품수거완료일시부터 1영업일 이상, 또는 반품신청일시부터',
  VIEW_INDEX_DELAY_RETURN_GUIDE2: '7영업일 이상 경과 되었으나 반품/환불처리 되지 않은 주문 건입니다.',
  VIEW_INDEX_DELAY_RETURN_GUIDE3: '교환수거완료일시부터 1영업일 이상, 또는 교환신청일시부터',
  VIEW_INDEX_DELAY_RETURN_GUIDE4: '10영업일 이상 경과 되었으나 교환완료처리 되지 않은 주문 건입니다.',
  VIEW_INDEX_DELAY_RETURN_GUIDE5: '상품문의 등록일부터 1영업일 이상 경과되었으나 답변하지 않은',
  VIEW_INDEX_DELAY_RETURN_GUIDE6: '문의건입니다. 영업일 기준 시간은 오전9시~오후6시 입니다.',
  VIEW_INDEX_DELAY_RETURN_GUIDE7: '배송보류 처리일시부터 3영업일 이상 경과된 주문 건입니다.',
  VIEW_INDEX_SPAN1: '처리가 지연될 경우 고객 불편이 예상되니 빠른 처리바랍니다.',
  VIEW_INDEX_DELIVERYDELAYCOUNT: '발송지연',
  VIEW_INDEX_CANCELDELAYCOUNT: '취소지연',
  VIEW_INDEX_RETURNDELAYCOUNT: '반품지연',
  VIEW_INDEX_EXCHANGEDELAYCOUNT: '교환지연',
  VIEW_INDEX_PRODUCTINQUIRYDELAYCOUNT: '답변지연',
  VIEW_INDEX_HOLDDELIVERYDELAY: '배송보류 지연',
  VIEW_INDEX_STATUSCANCELLATION: '클레임 현황',
  VIEW_INDEX_CANCELREQUESTCOUNT: '취소주문',
  VIEW_INDEX_RETURNREQUESTCOUNT: '반품주문',
  VIEW_INDEX_EXCHANGEREQUESTCOUNT: '교환주문',
  VIEW_INDEX_PRODUCTSTATUS: '상품 현황',
  VIEW_INDEX_APPROVALREADY: '승인대기',
  VIEW_INDEX_UPDATEDAPPROVALREADY: '수정 후 승인대기',
  VIEW_INDEX_ONSALE: '판매중인 상품',
  VIEW_INDEX_OUTOFSTOCK: '품절상품',
  VIEW_INDEX_DEADLINESEVENDAYS: '종료 7일전 상품',
  VIEW_INDEX_STOCKUNDERTEN: '재고 10개 이하 상품',
  VIEW_INDEX_PRODUCT_INQUIRY: '상품문의',
  VIEW_INDEX_PRODUCT_INQUIRY_DELAY: '미답변 문의',
  VIEW_INDEX_RECENTLY_ONE_YEAR: '최근 1년',
  VIEW_INDEX_PRODUCT_INQUIRY_ALL: '전체 문의내역',
  VIEW_INDEX_ONEBYONE_INQUIRY: '1:1 문의',
  VIEW_INDEX_ONEBYONE_INQUIRY_CONTENT: '1:1 문의 내역',
  VIEW_INDEX_ONEBYONE_INQUIRY_DELAY: '미답변 문의',
  VIEW_INDEX_ONEBYONE_INQUIRY_ALL: '전체 문의내역',
  VIEW_INDEX_IMFORMATION_PROTECT_GUIDE: '개인정보보호 가이드 다운로드',

  // login
  VIEW_LOGIN_ID_ISNULL_ERROR: '로그인 정보를 입력 해 주세요.',
  VIEW_LOGIN_PW_ISNULL_ERROR: '로그인 정보를 입력 해 주세요.',
  VIEW_LOGIN_MAIL_MESSAGE1: '운영자 e메일로 비밀번호 변경 링크를 전송합니다.',
  VIEW_LOGIN_MAIL_MESSAGE2: '운영자 아이디를 모르실 경우 마스터 운영자에게 문의하세요.',
  VIEW_LOGIN_ADMIN_ID_PLACEHOLDE: '운영자 아이디를 입력하세요.',
  VIEW_LOGIN_ADMIN_NAME_PLACEHOLDE: '운영자명을 입력하세요.',
  VIEW_LOGIN_ADMIN_SUCCESS_MESSAGE: '운영자님의 e메일 주소로 비밀번호 변경 링크가 전송되었습니다. 메일 함을 확인해 주세요.',
  VIEW_LOGIN_ADMIN_ID_ERROR: '필수 입력값이 제공되지 않았습니다.',
  VIEW_LOGIN_ADMIN_NAME_ERROR: '등록되지 않은 운영자 입니다.',
  VIEW_LOGIN_ADMIN_ERROR: '오류가 발생하였습니다.',
  ALERT_CHECK_PLAN_TYPE: '사용하시는 shop by 요금제는 \'{planType}\'입니다.\n{planType} 전용 로그인 페이지로 접근해주세요.',
  VIEW_LOGIN_ADMIN_FAIL_MESSAGE: '아이디 또는 비밀번호를 잘못 입력하였거나 등록되지 않은 아이디입니다.\n10회 이상 잘못 입력하실 경우 아이디가 잠금 처리 됩니다.',
  VIEW_LOGIN_ADMIN_ID: '운영자 아이디',
  VIEW_LOGIN_ADMIN_NAME: '운영자명',
  VIEW_LOGIN_ERROR2: '안전한 이용을 위하여 자동입력방지 문자를 입력해 주세요.', // view.login.error2
  VIEW_LOGIN_USERNAME_PLACEHOLDER: '아이디 입력', // view.login.username.placeholder
  VIEW_LOGIN_PASSWORD_PLACEHOLDER: '비밀번호 입력', // view.login.password.placeholder
  VIEW_LOGIN_REFRESH: '새로고침', // view.login.refresh
  VIEW_LOGIN_LISTEN: '음성으로 듣기', // view.login.listen
  VIEW_LOGIN_TEXT: '음성으로 안내되고 있습니다.', // view.login.text
  VIEW_LOGIN_4SECONDS: '(4초후 재생)', // view.login.4seconds
  VIEW_LOGIN_VIEWASIMAGE: '이미지로 보기', // view.login.viewasimage
  VIEW_LOGIN_AUTOFILL: '자동입력 방지문자 입력', // view.login.autofill
  VIEW_LOGIN_REMEMBER: '아이디 기억하기', // view.login.remember
  VIEW_LOGIN_INTEGRATED_ACCOUNT: '통합계정 여부',
  VIEW_COMMON_CHANGEPASSWORD: '비밀번호 변경', // view.common.changepassword

  // 2차인증
  SECOND_CERT_SMS: '외부접속 시 운영자 휴대폰 인증을 진행합니다.',
  SECOND_CERT_SMS_SENDED: '휴대폰 번호로 인증코드가 전송되었습니다.',
  SECOND_CERT_SMS_SEND: '인증코드 전송',
  SECOND_CERT: '운영자 인증 하기',
  SECOND_CERT_SMS_SUCCES: '외부접속 운영자 휴대폰 인증이 완료되었습니다.',
  SECOND_CERT_SMS_FAIL: '인증코드가 잘못 입력되었습니다.',
  SECOND_CERT_AUTH_CODE_INPUT: '인증코드를 입력해 주세요.',

  // main bottom
  MENU_NAME_QUICKMENU: '퀵메뉴',
  MENU_NAME_NOTICE: '공지사항',
  NOTICE_CATEGORY_ALL: '전체',
  NOTICE_CATEGORY_GENERAL: '일반',
  NOTICE_CATEGORY_PROMOTION: '프로모션 공지',
  NOTICE_CATEGORY_WARNING: '위해정보',
  NOTICE_CATEGORY_SAFETY_TRADE: '안전거래',
  NOTICE_CATEGORY_SYSTEM: '시스템',
  VIEW_INDEX_NOANNOUNCEMENTS: '공지사항이 없습니다.',
  VIEW_INDEX_VIEW_ALL_NOTICE: '공지사항 전체보기',
  VIEW_INDEX_BUSINESS_MESSAGE: '업무메세지 현황',
  VIEW_INDEX_BUSINESS_MESSAGE_PROCESSING: '처리중',
  VIEW_INDEX_BUSINESS_MESSAGE_CONTENT: '업무메세지 현황 내역',
  VIEW_INDEX_PROMOTION: '프로모션 현황',
  VIEW_INDEX_PROMOTION_CONTENT: '프로모션 내역',
  VIEW_INDEX_COUPON_ON: '발행 중 쿠폰',
  VIEW_INDEX_COUPON_END7: '발행 종료 7일 전 쿠폰',
  VIEW_INDEX_ADDITIONAL_DISCOUNT_ON: '할인 중 추가할인',
  VIEW_INDEX_ADDITIONAL_DISCOUNT_END7: '진행 종료 7일 전 추가할인',
  VIEW_INDEX_EVENTS: '기획전 현황',
  VIEW_INDEX_EVENTS_CONTENT: '기획전 내역',
  VIEW_INDEX_EVENTS_ON: '진행중 기획전',
  VIEW_INDEX_EVENTS_END3: '진행 종료 3일 전 기획전',
  VIEW_INDEX_MEMBER: '회원 현황',
  VIEW_INDEX_MEMBER_CONTENT: '회원 내역',
  VIEW_INDEX_MEMBER_JOIN: '회원 가입',
  VIEW_INDEX_MEMBER_LEAVE: '탈퇴 회원',
  VIEW_INDEX_CS_CENTER: '고객센터',
  VIEW_INDEX_CS_CENTER_CONTENT1: '02-6953-3581',
  VIEW_INDEX_CS_CENTER_CONTENT2: '운영시간 : 09:00~17:00 (점심 12:00~13:30)',
  VIEW_INDEX_CS_CENTER_CONTENT3: '(토/일/공휴일 휴무)',

  // footer
  VIEW_LAYOUT_DEFAULT_FOOTER_FOOTERCONTENT1: '상호: 엔에이치엔커머스(주) 대표: 김종승', //view.layout.default.footer.footercontent1
  VIEW_LAYOUT_DEFAULT_FOOTER_FOOTERCONTENT2: '주소: 서울시 구로구 디지털로 26길 72', // view.layout.default.footer.footercontent2
  VIEW_LAYOUT_DEFAULT_FOOTER_NEW_FOOTERCONTENT2: '주소: 서울특별시 구로구 디지털로26길 43, 대륭포스트타워 8차 R동 6~7층',
  VIEW_LAYOUT_DEFAULT_FOOTER_FOOTERCONTENT3: '사업자 등록번호: 120-86-46911 통신판매업신고번호: 2015-서울구로-0049', // view.layout.default.footer.footercontent3
  VIEW_LAYOUT_DEFAULT_FOOTER_BUSINESSINFOLINK: '사업자정보확인', // view.layout.default.footer.businessinfolink
  VIEW_LAYOUT_DEFAULT_FOOTER_PRIVACYNOTICE: '개인정보처리방침', // view.layout.default.footer.privacynotice
  VIEW_LAYOUT_DEFAULT_FOOTER_BUSINESSINFOLINK_NCP: 'shop by 사업자 정보확인', // view.layout.default.footer.businessinfolink.ncp

  COMMON_SELECTSHOPPINGMALL: '쇼핑몰 선택', // view.common.selectshoppingmall
  COMMON_KEYWORD: '검색어', // view.common.keyword
  COMMON_KEYWORD_PLACEHOLDER: '검색어', // view.common.keyword
  COMMON_ALL: '전체', // view.common.all
  COMMON_MEMBERNO: '회원번호', // view.common.memberNo
  COMMON_ADMINID: '아이디', // view.common.adminid
  COMMON_ID: '아이디',
  COMMON_NICKNAME: '닉네임', // view.common.nickname
  COMMON_ORDERNO: '주문번호', // view.common.orderno
  COMMON_POINT: '점', // view.common.point
  COMMON_PLACEHOLDER_NUMBER: '숫자만 입력', // view.common.placeholder.number
  COMMON_TIME2: '회', // view.common.time2
  COMMON_GENDER: '성별', // view.common.gender
  COMMON_MONTHS: '개월', // view.common.months
  COMMON_NOT_AGREED: '미동의', // view.common.not.use
  COMMON_AGREED: '동의', // view.common.use
  COMMON_NOT_INTEGRATE: '통합하지 않음', // view.common.not.use
  COMMON_INTEGRATE: '통합함', // view.common.use
  COMMON_NOT_USE: '미사용', // view.common.not.use함
  COMMON_NOT_USE_2: '사용 안 함',
  COMMON_USE: '사용', // view.common.use
  COMMON_USE_2: '사용함',
  COMMON_DATA_USE: '기간사용', // view.common.use
  COMMON_NOLOGIN: '로그인일자 없는 회원', // view.common.use
  COMMON_GANDER_MALE: '남자', // view.common.not.use
  COMMON_GANDER_FEMALE: '여자', // view.common.use
  COMMON_GANDER_UNKNOWN: '미분류',
  COMMON_CERTIFIED_Y: '인증완료',
  COMMON_CERTIFIED_N: '인증안함',
  COMMON_PC_WEB: 'PC웹',
  COMMON_MOBILE_WEB: '모바일웹',
  COMMON_MOBILE_APP: '모바일앱',
  COMMON_VIEWRESULTS: '조회결과', // view.common.viewresults
  COMMON_TOTAL: '총',
  COMMON_PEOPLE: '명',
  MEMBER_LIST_CRMBUTTON_RATING: '회원등급 변경', // view.member.list.crmbutton.rating
  MEMBER_LIST_CRMBUTTON_GROUP: '회원그룹 변경', // view.member.list.crmbutton.group
  MEMBER_LIST_CRMBUTTON_COUPON: '할인쿠폰 지급', // view.member.list.crmbutton.coupon
  MEMBER_LIST_PROHIBIT: '이용정지', // view.member.list.prohibit
  MEMBER_LIST_EXPEL: '강제탈퇴', // view.member.list.expel
  MEMBER_MODIFICATION_TYPE_ACCUMULATION: '적립금 지급/차감', // member.modification.type.accumulation

  MEMBER_LIST_ALL: '전체', // view.member.list.all
  MEMBER_LIST_AGREE: '동의', // view.member.list.agree
  MEMBER_LIST_DISAGREE: '미동의', // view.member.list.disagree

  COMMON_PAGESIZE_COUNT1: '30개',
  COMMON_PAGESIZE_COUNT2: '50개',
  COMMON_PAGESIZE_COUNT3: '100개',
  COMMON_PAGESIZE_COUNT4: '200개',
  COMMON_DATA1: '1개월',
  COMMON_DATA2: '3개월',
  COMMON_DATA3: '6개월',
  COMMON_DATA4: '12개월',
  COMMON_MALLTYPE_MALL: '쇼핑몰회원',
  COMMON_MALLTYPE_SYNC_ID: '연동아이디회원',
  COMMON_MALLTYPE_OPEN_ID: '오픈아이디 회원',
  COMMON_MALLTYPE_PAYCO: '페이코',
  COMMON_MALLTYPE_NAVER: '네이버',
  COMMON_MALLTYPE_KAKAO: '카카오',
  COMMON_MALLTYPE_FACEBOOK: '페이스북',
  COMMON_MALLTYPE_LINE: '라인',
  COMMON_MALLTYPE_GOOGLE: '구글',
  COMMON_MALLTYPE_APPLE: '애플',
  COMMON_MALLTYPE_APP_CARD: '앱카드',
  COMMON_NOT_DATA: '데이터가 존재하지 않습니다.',
  COMMON_NOT_DATA2: '회원연동일없음', // view.common.not.data
  COMMON_RESULT_NONE: '조회 결과가 없습니다.',
  COMMON_POSITION: '직급',
  COMMON_DEPARTMENT: '소속부서', //view.common.department
  COMMMON_DUTY: '직책', //view.common.duty
  COMMON_TELPHONE: '전화번호', //view.common.telphone
  COMMON_NUMBER_ONLY: '숫자와 - 만 입력 가능', //view.common.onlynumber
  COMMON_CHANGE_INDENTITY: '인증번호발송', //view.common.change.indentity
  COMMON_CERTIFIED_CELLPHONENUMBER: '인증완료 된 휴대폰번호입니다 ', //view.common.certified.cellphonenumber
  COMMON_SENDED_CERTIFY_CODE: '휴대폰 번호로 인증코드가 전송되었습니다.',
  COMMON_RE_CHECK_CELLPHONENUMBER: '휴대폰번호를 다시 확인 해 주세요.',
  COMMON_INSERT_CERTIFY_CODE: '인증코드 입력',
  COMMON_COMPLETE_CERTIFIED: '인증 완료되었습니다.',
  COMMON_WRONG_CERTIFY_CODE: '인증코드가 잘못 입력되었습니다. 다시 확인해 주세요.',
  COMMON_SAVE_CHANGES: '변경사항 저장', //view.common.save.changes
  COMMON_MESSAGE_CHANGE: '운영자 계정 정보가 변경되었습니다.',

  COMMON_SETTING: '설정',
  COMMON_NOT_SETTING: '설정안함',
  COMMON_SIZE: '사이즈',
  COMMON_LEFT: '좌',
  COMMON_RIGHT: '우',
  COMMON_GENERAL: '일반',
  COMMON_CATEGORY: '카테고리',
  COMMON_NEW_CATEGORY: '신규 카테고리',
  COMMON_SERVER_ERROR: '서버 오류 발생',
  COMMON_ERR_MALLNO_NULL: '쇼핑몰을 선택해주세요.',
  COMMON_NO_EXCEL_ERROR: '엑셀 파일을 등록해주세요.',
  COMMON_NO_RESULTS: '검색결과가 없습니다.',
  COMMON_MAY: '가능',
  COMMON_UNABLE: '불가능',
  COMMON_NOT_SET: '설정안함',
  COMMON_BTN_NEXT: '다음',
  COMMON_BTN_PREV: '이전',
  COMMON_PERSONS: '명',
  COMMON_COLOR: '색상',
  ALERT_WRONG_ACCESS: '잘못된 접근입니다.',
  ALERT_NO_DOWNLOAD_PERMISSION: '다운로드 권한이 없습니다.',
  CONFIRM_UNSAVED: '사이트에서 나가시겠습니까?\n변경사항이 저장되지 않을 수 있습니다.',
  CHANGE_MALL_ALERT: '페이지 이동 시 변경된 내용은 저장되지 않습니다. 저장하지 않고 이동하시겠습니까?',
  ALERT_DISALLOW_EXTENSION: '허용하지 않는 확장자입니다.',

  // noun
  PRODUCT: '상품',
  ORDER: '주문',
  CLAIM: '클레임',
  MEMBER: '회원',
  MANAGE: '운영',
  PROMOTION: '프로모션',
  PARTNER: '파트너',
  STATISTICS: '통계',
  ADVANCED_SEARCH: '상세검색',
  DOWNLOAD: '다운로드',
  REQUEST: '요청',
  REASON: '사유',
  PASSWORD: '비밀번호',
  CREATE: '생성',
  CANCEL: '취소',
  VERIFY_MESSAGE_GENDER: '회원성별을 선택해 주세요',
  SERVICE: '서비스',
  SETTLEMENT: '정산',

  LIMIT_N: '제한없음',
  LIMIT_Y: '제한있음',

  PAY_DONE: '결제완료',

  ALERT_SAVE_SUCCESS: '저장되었습니다.',
  ALERT_DELETE_SUCCESS: '삭제되었습니다.',
  DIRECT_INPUT: '직접입력',
  LOGO_IMAGE: '로고이미지',

  USABLE_Y: '사용함',
  USABLE_N: '사용 안 함',
  ALLOWABLE_Y: '허용함',
  ALLOWABLE_N: '허용 안 함',

  PLACEHOLDER_PARTNER: '파트너사명 입력',

  TAG_INPUT_PLACEHOLDER: '태그 입력',
  TAG_NUMBER_LIMIT_ALERT_MSG: '태그는 최대 {number}개까지만 등록 가능합니다.',

  SEARCH_FILE: '파일찾기',

  SEARCH_RESULT_COUNT: '검색결과 총 {count}건',

  SUCCESS_N: '성공 {count}건',
  FAIL_N: '실패 {count}건',
  ALL_SELECT: '전체 선택',
  FAVORITE: '즐겨찾기',

  POPUP: {
    NOT_SHOW_N_DAY: '{0}일간 다시 보지 않기',
    NOT_SHOW_FOREVER: '다시 보지 않기',
    NOT_TODAY_SHOW: '오늘 하루 보이지 않음',
    CLOSE: '닫기',
  }
});
